import omnivore from 'leaflet-omnivore'
import store from '@/store'

const SHAPE_MUNICIPIOS_ESTADO = store.state.userInterface.dadosEstado.SHAPE_MUNICIPIOS_ESTADO
const SIGLA_ESTADO = store.state.userInterface.dadosEstado.SIGLA_ESTADO

const municipiosTopoJson = () => import('./seeds/' + SHAPE_MUNICIPIOS_ESTADO)

class TopoJsonHelper {
  static getTopoJson () {
    return new Promise((resolve) => {
      municipiosTopoJson().then((results) => {
        const layerMunicipios = omnivore.topojson.parse(results.layer)

        layerMunicipios.eachLayer((layer) => {
          layer.bindTooltip(`${layer.feature.properties.nome} - ${SIGLA_ESTADO}`, {
            interactive: true,
            sticky: true,
            opacity: 0.9,
            direction: 'right',
            className: 'custom-tooltip'
          })
        })

        layerMunicipios.setStyle({
          fill: true,
          fillColor: 'transparent',
          weight: 1.5,
          color: '#c8c8c8'
        })

        resolve(layerMunicipios)
      })
    })
  }
}
export default TopoJsonHelper



// WEBPACK FOOTER //
// ./src/libs/static/municipio/topoJsonHelper.js